import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ProductFeatures = () => {
  const { product } = useProductDetail();

  if (
    !product?.specifications?.attributes ||
    product.specifications.attributes.length === 0
  ) {
    return null;
  }

  return (
    <div className="space-y-1">
      <h2 className="font-medium text-sm my-4">
        {product.specifications.title || "Öne Çıkan Özellikler:"}
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
        {product.specifications.attributes.map((attr, index) => (
          <article
            key={index}
            className="bg-[#e5e5e5] text-black flex flex-col items-start gap-1 py-2 px-2 rounded-sm border border-[#e5e5e5] transition-all duration-300 ease-in-out hover:border-black"
          >
            <p className="text-xs">{attr.label}</p>
            <p className="text-sm font-medium">{attr.value}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ProductFeatures;
